import { Modal } from 'antd';
import React from 'react'
import { CloseCircleOutlined } from '@ant-design/icons';


function QuestionAnswersModal({ isOpenModal, setIsOpenModal, choiceIndex, gameAssets }) {
    const title = ["That's the best option!", "That's an interesting choice!", "That's a good choice!", " Ohh, you've got this wrong!"]
    return (
        <Modal
            visible={isOpenModal}
            onCancel={() => setIsOpenModal(false)}
            footer={null}
            className='token-model'
            width={1000}
            style={{ height: "90dvh" }}
            centered={true}
            closeIcon={false}
            maskClosable={false}
        >
            <div className="r-c-c-c parent-qa">
                <div className='r-c-c' style={{}} >
                    <div className="letsPlay-intro modal-text" style={{}}>
                        {title[choiceIndex]}
                    </div>
                </div>
                <div className='modal-close r-c-fe' ><CloseCircleOutlined onClick={() => setIsOpenModal(false)} style={{ fontSize: 22 }} /></div>
                <div className="r-c-c modal-img " ><img className='full-img' src={gameAssets?.metaInfoBg} alt="lets play" /> </div>
                <div className="r-c-c modal-img-1" ><img className='full-img' style={{ objectFit: "contain" }} src={choiceIndex == 3 ? gameAssets?.badGateImg : gameAssets?.goodGateImg} alt="lets play" /></div>
            </div>
        </Modal>
    );
}

export default QuestionAnswersModal
